$(document).ready(function () {
    var config = {'appContext': '/'},
    application = new T.Application(document, config);
    application.registerModules();
    application.start();
});
